<template>
  <div
    class="flex items-center justify-center border-neutral-500"
    :class="`${variant}-${weight}`"
    :style="{ borderStyle: type }"
  />
</template>

<script setup lang="ts">
import type { SeparatorProps } from "~/types/schemas/common/Atom/separator";

withDefaults(defineProps<SeparatorProps>(), {
  variant: "horizontal",
  weight: "thin",
  type: "solid",
});
</script>

<style scoped>
.vertical-thin {
  @apply border-r-[0.5px];
  width: 0 !important;
}

.vertical-medium {
  @apply border-r;
  width: 0 !important;
}

.vertical-bold {
  @apply border-r-[1.5px];
  width: 0 !important;
}

.horizontal-thin {
  @apply border-t-[0.5px];
  height: 0 !important;
}

.horizontal-medium {
  @apply border-t;
  height: 0 !important;
}

.horizontal-bold {
  @apply border-t-[1.5px];
  height: 0 !important;
}
</style>
